// Package billing.v3 defines the protocol buffer services for general billing operations
// within the platform. This service provides high-level billing operations like checkout
// session creation that orchestrate multiple billing components.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file billing/v3/billing_service.proto (package billing.v3, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { CreatePortalSessionRequestSchema, CreatePortalSessionResponseSchema } from "./portal_pb";
import { file_billing_v3_portal } from "./portal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file billing/v3/billing_service.proto.
 */
export const file_billing_v3_billing_service: GenFile = /*@__PURE__*/
  fileDesc("CiBiaWxsaW5nL3YzL2JpbGxpbmdfc2VydmljZS5wcm90bxIKYmlsbGluZy52MyKAAgoVQ3JlYXRlQ2hlY2tvdXRSZXF1ZXN0EhoKDHByb2R1Y3RfdHlwZRgBIAEoCUIEgLUYARIZCgtzdWNjZXNzX3VybBgCIAEoCUIEgLUYARIYCgpjYW5jZWxfdXJsGAMgASgJQgSAtRgBEkEKCG1ldGFkYXRhGAQgAygLMi8uYmlsbGluZy52My5DcmVhdGVDaGVja291dFJlcXVlc3QuTWV0YWRhdGFFbnRyeRIVCghxdWFudGl0eRgFIAEoA0gAiAEBGi8KDU1ldGFkYXRhRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4AUILCglfcXVhbnRpdHkicAoWQ3JlYXRlQ2hlY2tvdXRSZXNwb25zZRIUCgxjaGVja291dF91cmwYASABKAkSLAoKc2Vzc2lvbl9pZBgCIAEoCUIYmrUYFHN0aWQuUGF5bWVudENoZWNrb3V0EhIKCmV4cGlyZXNfYXQYAyABKAky1QEKDkJpbGxpbmdTZXJ2aWNlElkKDkNyZWF0ZUNoZWNrb3V0EiEuYmlsbGluZy52My5DcmVhdGVDaGVja291dFJlcXVlc3QaIi5iaWxsaW5nLnYzLkNyZWF0ZUNoZWNrb3V0UmVzcG9uc2UiABJoChNDcmVhdGVQb3J0YWxTZXNzaW9uEiYuYmlsbGluZy52My5DcmVhdGVQb3J0YWxTZXNzaW9uUmVxdWVzdBonLmJpbGxpbmcudjMuQ3JlYXRlUG9ydGFsU2Vzc2lvblJlc3BvbnNlIgBCXVpbZ2l0aHViLmNvbS9TdG9yeXRlbGwtYWkvc3Rvcnl0ZWxsLWFpLXBsYXRmb3JtL3BrZy9nby9kb21haW5zL2NwL2dlbi9wYi9iaWxsaW5nL3YzO2JpbGxpbmdWM2IGcHJvdG8z", [file_common_v3_common, file_billing_v3_portal]);

/**
 * CreateCheckoutRequest for creating a new checkout session
 *
 * @generated from message billing.v3.CreateCheckoutRequest
 */
export type CreateCheckoutRequest = Message<"billing.v3.CreateCheckoutRequest"> & {
  /**
   * ProductType is the product type (e.g., "pro", "team", "credits") that the user wants to purchase
   *
   * @generated from field: string product_type = 1;
   */
  productType: string;

  /**
   * SuccessURL is where customers are redirected after successful payment
   *
   * @generated from field: string success_url = 2;
   */
  successUrl: string;

  /**
   * CancelURL is where customers are redirected if they cancel payment
   *
   * @generated from field: string cancel_url = 3;
   */
  cancelUrl: string;

  /**
   * Metadata contains custom key-value pairs for this session
   *
   * @generated from field: map<string, string> metadata = 4;
   */
  metadata: { [key: string]: string };

  /**
   * Quantity is the number of units to purchase (optional, defaults to 1)
   * For subscription products (pro, team): must be 1 or unspecified
   * For usage products (credits): must be 1 or more
   *
   * @generated from field: optional int64 quantity = 5;
   */
  quantity?: bigint;
};

/**
 * Describes the message billing.v3.CreateCheckoutRequest.
 * Use `create(CreateCheckoutRequestSchema)` to create a new message.
 */
export const CreateCheckoutRequestSchema: GenMessage<CreateCheckoutRequest> = /*@__PURE__*/
  messageDesc(file_billing_v3_billing_service, 0);

/**
 * CreateCheckoutResponse for checkout session creation
 *
 * @generated from message billing.v3.CreateCheckoutResponse
 */
export type CreateCheckoutResponse = Message<"billing.v3.CreateCheckoutResponse"> & {
  /**
   * CheckoutURL is the Stripe checkout page URL where customers complete payment
   *
   * @generated from field: string checkout_url = 1;
   */
  checkoutUrl: string;

  /**
   * SessionID is the internal payment checkout session ID for tracking
   *
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * ExpiresAt indicates when the checkout session expires
   *
   * @generated from field: string expires_at = 3;
   */
  expiresAt: string;
};

/**
 * Describes the message billing.v3.CreateCheckoutResponse.
 * Use `create(CreateCheckoutResponseSchema)` to create a new message.
 */
export const CreateCheckoutResponseSchema: GenMessage<CreateCheckoutResponse> = /*@__PURE__*/
  messageDesc(file_billing_v3_billing_service, 1);

/**
 * BillingService provides high-level billing operations for the platform.
 * This service orchestrates multiple billing components to provide complete billing workflows.
 *
 * @generated from service billing.v3.BillingService
 */
export const BillingService: GenService<{
  /**
   * CreateCheckout creates a new checkout session for subscription billing.
   * This method handles customer creation (if needed), plan validation, and checkout session creation.
   *
   * @generated from rpc billing.v3.BillingService.CreateCheckout
   */
  createCheckout: {
    methodKind: "unary";
    input: typeof CreateCheckoutRequestSchema;
    output: typeof CreateCheckoutResponseSchema;
  },
  /**
   * CreatePortalSession creates a customer portal session for subscription management.
   * This method allows customers to manage their billing information, subscriptions, and payment methods.
   *
   * @generated from rpc billing.v3.BillingService.CreatePortalSession
   */
  createPortalSession: {
    methodKind: "unary";
    input: typeof CreatePortalSessionRequestSchema;
    output: typeof CreatePortalSessionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_billing_v3_billing_service, 0);

